import wpautop from 'wpautop'

export default function (value: string): string {
  // We have set br (second arg) to always be false in ticketing-web.
  return wpautop(value, false)
}
